<template>
  <div v-if="!showRequest">
    <app-all />
    <v-card class="fullForm">
      <div class="fullText">
        <ul>
          <li>
            شما در اين بخش قادر خواهيد بود، بصورت سيستمي،‌ درخواست خود مبني بر
            صدور مدرك تحصيلي را ارسال فرمائيد.
          </li>
          <li>
            درخواست شما توسط واحدهاي مربوطه مركز مديريت بررسي و در صورت تاييد،
            مدرك براي شما صادر خواهد شد.
          </li>
          <li>
            ضمنا شما مي توانيد در بخش مشاهده سوابق اقدام به پيگيري درخواست خود
            نمائيد.
          </li>
          <li>
            تصویر چاپ شده بر روی مدرک می بایست جدید، رنگی و با کیفیت عالی باشد.
            (برای برادران معمم و برای خواهران تمام رخ -رنگي با زمينه سفيد -با
            چادر -بدون عينك) لذا در صورتیکه تصویر ثبت شده ی شما در سامانه، دارای
            چنین ویژگی هایی نمی باشد، از
            <a href="/change-picture-request"> این بخش </a>
            اقدام به ارسال تصویر جدید از خود نمائید
          </li>
          <li>
            بعد از آماده شدن مدرك، اطلاع رساني از طريق پيامك صورت خواهد گرفت.
          </li>
          <li>
            دقت شود پس از دريافت پيامك مبني بر صدور مدرك، جهت تحويل مراجعه
            نماييد.
          </li>
          <li>
            لطفا بعد از مطالعه مجموعه قوانين صدور مدرك و تایید آن، جهت ارسال
            درخواست خود ، دکمه درخواست مدرک را کلیک فرمایید.
          </li>
        </ul>
        <br />
        <div style="width: 100%">
          <v-simple-checkbox @input="handleShowRequest" v-model="showRequest" :ripple="false"></v-simple-checkbox>
          <b>موارد فوق را با دقت مطالعه كردم و نسبت به رعایت آن متعهد مي شوم.</b>
        </div>
      </div>
    </v-card>
  </div>
  <div v-else>
    <v-card class="form">
      <v-card-text>
        نوع مدركي كه درخواست صدور آن را داريد، مشخص نموده و در صورت نياز
        توضيحاتي را درج فرمائيد. ضمنا جنانچه قصد الصاق مستنداتي به درخواست خود
        داريد، فايل مورد نظر خود را در بخش پيوست مستندات مشخص نمائيد.
      </v-card-text>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>نوع مدرك تحصيلي:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select :items="items" item-text="text" item-value="value" v-model="type"></v-select>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input label="پيوست مستندات" v-model="image"></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn color="primary white--text" class="register" rounded @click="applyRequest" :disabled="apiRunning">
          {{ apiRunning ? "لطفا منتظر بمانید..." : "درخواست مدرک" }}
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { requestMadrak } from "@/api/madrak";
import HistoryButton from "@/components/HistoryButton";

export default {
  data() {
    return {
      showRequest: false,
      image: null,
      items: [
        { value: 1, text: "دانشنامه سطح يك" },
        { value: 2, text: "دانشنامه سطح دو" },
        { value: 3, text: "دانشنامه سطح سه" },
        { value: 4, text: "دانشنامه سطح چهار" },
      ],
      type: 0,
      comment: "",
    };
  },

  methods: {
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.type) {
        text = "لطفا سطح را انتخاب کنید.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        requestMadrak(this.image, this.type, this.comment)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.type = 0;
              this.comment = "";
              this.image = null;
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    handleShowRequest() {
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showRequest: "true"
        }
      });

    }
  },
  /**
   * get khorooji meta data
   */
  created() {
    if (this.$route.query.showRequest) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getMadrakInfo");
  },
  computed: {
    madrakInfo() {
      return this.$store.getters.madrakInfo;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  watch: {

    '$route'(to, from) {
      this.showRequest = !!this.$route.query.showRequest;
      window.scrollTo(0, 0)
    }
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}

.v-simple-checkbox {
  top: -5px;
  position: relative;
  margin: 2px 0 0 5px;
  float: right;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
